import { SideMenuItem } from './side-menu-item';

export class ToggleSideMenuRequest {
  constructor(
    public item?: SideMenuItem,
    public toggle?: boolean,
    public selectIndex?: number,
    public open?: boolean,
    public close?: boolean
  ) {}
}
